import React, { useCallback, useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { getClientQueries } from '../../../api';
import { columns } from './Consultas.columns';

export default function Consultas({ cliente_id }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);

  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 20,
  });

  const fetchQueries = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getClientQueries(cliente_id, {
        page: pagination.page,
        perPage: pagination.perPage,
      });

      setData(response.data.data);
      setTotalRows(response.data.pagination.total);
    } finally {
      setLoading(false);
    }
  }, [cliente_id, pagination]);

  useEffect(() => {
    fetchQueries();
  }, [fetchQueries]);

  const handlePageChange = (page) => {
    setPagination((prev) => ({ ...prev, page }));
  };

  const handlePerPageChange = (newPerPage, page) => {
    setPagination({ page, perPage: newPerPage });
  };

  return (
    <>
      <h3 className="mb-5">Consultas do JUSFINDER</h3>

      <div className="row mb-5">
        <DataTable
          columns={columns}
          data={data}
          progressPending={loading}
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handlePerPageChange}
        />
      </div>
    </>
  );
}
